import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider, Spinner, Center,useColorMode } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState, lazy, Suspense,useEffect } from 'react';
import { UserProvider } from "./contexts/UserContext";
import CreateNnewPassword from 'views/auth/forgetpassword/Create_new_password';
import { SelectedUserProvider } from 'utils/SelectUserContext';
import ErrorBoundary from 'components/ErrorBoundary';

// Lazy load layouts and pages
import Swal from "sweetalert2";
import { ProjectProvider } from 'contexts/ProjectContext';
import { AppProvider } from 'utils/RefreshGuideline';
const AuthLayout = lazy(() => import('./layouts/auth'));
const AdminLayout = lazy(() => import('./layouts/admin'));
const VideoLayout = lazy(() => import('./layouts/VedioGeneration/Index.jsx'));
const AgentLayout = lazy(()=>import("./layouts/AgentLayout/index"))
const ViewThumbnails = lazy(() => import('./views/admin/AgentThumbnails/ViewThumbnails'));
const PixxEvidenceShare = lazy(() => import('./views/public/PixxEvidenceShare'));

const NotFound = lazy(() => import('views/404Page'));

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const [themes,setthemes]=useState("")
  useEffect(()=>{
    const theme = localStorage.getItem("chakra-ui-color-mode")
setthemes(theme)
    
  })

  const { colorMode } = useColorMode();
  function ThemeWrapper({ children }) {
  

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", colorMode);
  }, [colorMode]);

  return children;
}



const isDark = themes == "dark";




const showOfflineAlert = (isDark) => {
  Swal.fire({
    title: "No Internet!",
    text: "Please check your connection.",
    icon: "warning",
    allowOutsideClick: false,
    background: isDark ? "#14225C" : "#fff",
    color: isDark ? "#fff" : "#000",
    confirmButtonColor: isDark ? "#4A6CFF" : "#3085d6",
  });
};

const showOnlineAlert = (isDark) => {
  Swal.fire({
    title: "Back Online!",
    text: "Internet restored.",
    icon: "success",
    timer: 1500,
    showConfirmButton: false,
    background: isDark ? "#14225C" : "#fff",
    color: isDark ? "#fff" : "#000",
  });
};

// Removed aggressive connection change listener as it causes false positives
useEffect(() => {
  // connection listener removed
}, [isDark]);


  return (
    <AppProvider>
    <UserProvider>
    <SelectedUserProvider>
    <ProjectProvider>
      <ChakraProvider theme={currentTheme}>
        <ErrorBoundary>
        <ThemeWrapper>
        <Suspense
          fallback={
            <Center h="100vh">
              <Spinner size="xl" color="blue.500" />
            </Center>
          }
        >
          <Routes>
            <Route path="auth/*" element={<AuthLayout />} />
            <Route
              path="admin/*"
              element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            <Route
              path="pixx-evidence/:jobId"
              element={<PixxEvidenceShare />}
            />
            <Route
              path="agent/view-thumbnails"
              element={<ViewThumbnails />}
            />
            <Route
              path="agent/*"
              element={<AgentLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            <Route
              path="videocreate/*"
              element={<VideoLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            
            <Route
              path="/create-new-password/:token"
              element={<CreateNnewPassword />}
            />
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        </ThemeWrapper>
        </ErrorBoundary>
      </ChakraProvider>
      </ProjectProvider>
      </SelectedUserProvider>
    </UserProvider>
    </AppProvider>
  );
}
